/* eslint-disable prefer-destructuring */

const VITE_APP_ENV = import.meta.env.VITE_APP_ENV;

if (!VITE_APP_ENV) {
  throw new Error('VITE_APP_ENV env var is missing');
}

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

if (!VITE_APP_API_URL) {
  throw new Error('VITE_APP_API_URL env var is missing');
}

const VITE_APP_WEBSITE_URL = import.meta.env.VITE_APP_WEBSITE_URL;

if (!VITE_APP_WEBSITE_URL) {
  throw new Error('VITE_APP_WEBSITE_URL env var is missing');
}

const VITE_APP_PLATFORM_URL = import.meta.env.VITE_APP_PLATFORM_URL;

if (!VITE_APP_PLATFORM_URL) {
  throw new Error('VITE_APP_PLATFORM_URL env var is missing');
}

const VITE_APP_STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY;

if (!VITE_APP_STRIPE_PUBLISHABLE_KEY) {
  throw new Error('VITE_APP_STRIPE_PUBLISHABLE_KEY env var is missing');
}

const VITE_APP_PAYPAL_CLIENT_ID = import.meta.env.VITE_APP_PAYPAL_CLIENT_ID;

if (!VITE_APP_PAYPAL_CLIENT_ID) {
  throw new Error('VITE_APP_PAYPAL_CLIENT_ID env var is missing');
}

const VITE_APP_AMPLITUDE_API_KEY = import.meta.env.VITE_APP_AMPLITUDE_API_KEY;

if (!VITE_APP_AMPLITUDE_API_KEY) {
  throw new Error('VITE_APP_AMPLITUDE_API_KEY env var is missing');
}

export const APP_ENV = VITE_APP_ENV;

export const API_URL = VITE_APP_API_URL;

export const WEBSITE_URL = VITE_APP_WEBSITE_URL;

export const STRIPE_PUBLISHABLE_KEY = VITE_APP_STRIPE_PUBLISHABLE_KEY;

export const PAYPAL_CLIENT_ID = VITE_APP_PAYPAL_CLIENT_ID;

export const PLATFORM_URL = VITE_APP_PLATFORM_URL;

export const AMPLITUDE_API_KEY = VITE_APP_AMPLITUDE_API_KEY;
